import React, { useEffect } from "react";
import Container from "../../container";

import Disease from "./disease";
import SelectPatient from "./select-patient";
import { useSelector } from "react-redux";
import { setSelectedPatient } from "../../redux/actions/patient.actions";
import { push } from "../../services/navigate";
export default function App() {
  const selectedPatient = useSelector(
    (state) => state.patientReducer.patientSelected
  );

  const telemedicina = useSelector((state) => state.userReducer.telemedicina);
  const homePage = useSelector((state) => state.userReducer.homePage);
  if (!telemedicina) {
    push(homePage);
  }

  useEffect(() => {
    localStorage.removeItem("@change_plan");
    localStorage.removeItem("@current_plan");
    localStorage.removeItem("@buy_token");
  }, []);

  return (
    <Container>
      {selectedPatient ? (
        <Disease onClose={setSelectedPatient} />
      ) : (
        <SelectPatient setSelectedPatient={setSelectedPatient} />
      )}
    </Container>
  );
}
